import { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../images/Charter-Logo.png";
import bg from "../../images/systemBg.jpg";
import { toast } from "react-toastify";
import api from "../../api/axiosInstance";
const ForgetPassword = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleSubmit = () => {
    var config = {
      method: "patch",
      url: process.env.REACT_APP_API_URL + "Users/ForgetPassword/" + email,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
      },
    };

    api(config)
      .then(function (response) {
        if (response.data.statusCode === 200) {
          toast.success("Forget Password Email Sent");
          navigate("/Login");
        }
        else{
            toast.error("Make sure you are user in the system");
        }
      })
      .catch(function (error) {
        if (error.code === "ERR_NETWORK")
          toast.error("Please check you connection");
        toast.error(error);
      });
  };
  return (
    <>
      <div
        className="container-fluid h-100vh loginPage"
        style={{ backgroundImage: `url(${bg})` }}
      >
        <div className="row align-items-center justify-content-center">
          <div className="col-md-10 col-lg-8 col-xl-6 col-xxl-4 login-box">
            <img src={logo} className="logo" alt="CTS HR System Logo" />
            <div className="row">
              <div className="col-12 mb-3">
                <h3>Welcome to Canvas Analyzer Portal</h3>
                <h4>Forget Password</h4>
              </div>
              <div className="col-12 mb-1">
                <input
                  placeholder="Enter e-Mail Here"
                  name="email"
                  autocomplete="off"
                  className="form-control bg-transparent"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="col-12">
                <button
                  type="button"
                  id="kt_password_reset_submit"
                  className="btn btn-primary me-4"
                >
                  <span
                    className="indicator-label"
                    onClick={() => handleSubmit()}
                  >
                    Send Forget Password
                  </span>
                </button>
              </div>
            </div>
            <p className="footer-login-box">
              Developed By: CTS - All Rights Reserved - V1.0.2023
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;
